import { BusinessUnitAddressResolverBase } from './business-unit-address.resolver.base';
import { BusinessUnitAddressService } from './business-unit-address.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class BusinessUnitAddressResolver extends BusinessUnitAddressResolverBase {

  constructor(protected service: BusinessUnitAddressService) {
    super(service);
  }
}



